import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="17" height="17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M8.879 2.409v8.64h-.8V2.41l-1.72 1.718-.565-.566L8.478.877l2.685 2.684-.566.566L8.879 2.41z" fill="#fff" /><path d="M2.875 6.08v8.806h11.208V6.08h.8v9.607H2.074V6.08h.8z" fill="#fff" /></svg>;